import { SET_DEALER_LOCALE } from './actionTypes';

export const setDealerLocale = dealerLocale => {
  return {
    type: SET_DEALER_LOCALE,
    payload: dealerLocale
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/dealerLocale/actions.js